import { size } from 'mol-ui';
import styled from 'styled-components';
import {
    Col,
    Container
} from 'reactstrap';

export const ContainerStyled = styled(Container) `
    background: ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
`;

export const ColStyled = styled(Col) `
    margin-bottom: 10px;
    margin-top: 10px;
`;

export const InfoComments = styled.div `
    max-height: 400px;
    overflow-y: auto;
`;

export const InfoRow = styled.div `
    border-bottom: 1px dashed ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    font-size: 14px;
    min-width: 600px;
    padding: 10px 5px;
    width: 100%;
    ${ size.md(`
        border-bottom: 0px;
    
    `) }

    &:last-child {
        border-bottom: none;
    }
`;

export const Message = styled.div `
    font-style: italic;
`;

export const Title = styled.div `
    text-align: center;
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 15px;
    ${ size.md(`
         font-size: 0.8rem;
    `) }
`;
